import { render, staticRenderFns } from "./Temperature.vue?vue&type=template&id=38d74aa9&scoped=true&"
import script from "./Temperature.vue?vue&type=script&lang=ts&"
export * from "./Temperature.vue?vue&type=script&lang=ts&"
import style0 from "./Temperature.vue?vue&type=style&index=0&id=38d74aa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d74aa9",
  null
  
)

export default component.exports